<template>
  <div class="notification">
    <loading v-if="loading"></loading>
    <div v-else>
      <p class="watermark" v-if="all_notifications.length === 0">Notifications</p>
      <div v-else class="notification_item" v-for="item in all_notifications" :key="item.id">
        <div class="the_img">
          <i  class="img far fa-bell"></i>
        </div>
        <div class="notification_title">
          <div class="text">
            <p> {{item.message}} .</p>
            <p>{{ item.created_at }}</p>
          </div>
          <div class="action_button">
            <q-btn icon="fas fa-trash" flat>
              <q-menu content-class="confirm_model_box" self="center end">
                <q-list style="min-width: 100px">
                  <q-item clickable v-close-popup>
                    <div class="confirm_model">
                      <p>Do you really want to delete this notice?</p>
                      <div>
                        <div class="the-button">
                          <!--                <span class="skew-line-w"></span>-->
                          <button @click="delete_notification(item.id)"  class="wro-button secondaryButtons"><span>Yes</span></button>
                          <button  class="wro-button secondaryButtons no"><span>No</span></button>
                        </div>
                      </div>


                    </div>
                  </q-item>
                </q-list>
              </q-menu>
            </q-btn>

            <!-- Confirm -->
            <!--          <div class="confirm_model">-->
            <!--            <p>Do you really want to delete this notice?</p>-->
            <!--            <div>-->
            <!--              <div class="the-button">-->
            <!--&lt;!&ndash;                <span class="skew-line-w"></span>&ndash;&gt;-->
            <!--                <button  class="wro-button secondaryButtons"><span>Yes</span></button>-->
            <!--                <button  class="wro-button secondaryButtons no"><span>No</span></button>-->
            <!--              </div>-->
            <!--            </div>-->
            <!--          </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading/loading";
export default {
  components: {Loading},
  data:() => ({
    all_notifications: [],
    loading: true,
  }),
  methods: {
    delete_notification(notification_id) {
      this.$API.notification.delete_notification({
        notification_id: notification_id,
      })
      .then(response => {
        this.$q.notify({
          message: response.data.message,
          color: 'green'
        })

      this.get_notification();
      }).catch(() => {});
    },
    get_notification() {
      this.$API.notification.get_notification()
          .then(response => {
            this.all_notifications = response.data.data;
            this.loading = false;
          }).catch(() =>{});
    }
  },
  mounted () {
    this.get_notification();
  }
}
</script>